var path = 'msi/shipments/skip-shipment/views/skip-shipment-button.html';
var html = "<button type=\"button\" ng-click=\"$ctrl.skip()\">{{'SHIPMENT_SKIP_BUTTON' | translate}}</button>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;